import { Component, Vue, Watch } from 'vue-property-decorator';
import moment from 'moment';
moment.locale('zh-cn');
import changeAirport from '../../../assets/js/airport/changeAirport';
import SelectPerson from '../../../components/SelectPerson.vue';
import config from '../../../api/params.config';
import Workflow from '../Workflow';
import { Dialog } from 'vant';
import SelectDropdown from '@/components/SelectDropdown.vue';

@Component({
  components: {
    SelectPerson,
    SelectDropdown,
  },
  filters: {
    Date(data: string) {
      return moment(data).format('MM-DD');
    },
    Week(data: string) {
      return moment(data).format('dddd');
    },
    City(data: string) {
      return changeAirport.changeAirportCode(data).cityCName || '无';
    },
    ServiceLevel(data: string) {
      const ServiceLevel: any = {
        F: '头等舱',
        C: '商务舱',
        Y: '经济舱',
      };
      return ServiceLevel[data] || '';
    },
    Discount(data: number) {
      return data ? (data * 10).toFixed(1) : '';
    },
    AirPort(data: string) {
      return changeAirport.changeAirportCode(data).airportCName || '无';
    },
  },
})
export default class AirTicketSubmit extends Vue {
  private $api: any;
  private isLoading: boolean = false;
  private windowHeight: number = 0;             // 窗口高度，解决小键盘顶起footer的问题
  private footerPosition: string = 'fixed';  // 底栏定位，解决小键盘顶起footer的问题
  private Reasons: any = []; // 退改签原因数据源
  private reason: any = ''; // 选择的原因
  private Remark: any = ''; // 备注
  private userRoleType: number = 0;       // 用户类型 0(普通员工) 1(部门经理) 2(订票专员)
  private AirTicketFor: any;              // 订票 改签 重订 ? 'booking' 'change' 'rebooking'
  private AirTicketTrip: any;             // 订票用的行程(订票专员帮订可能为空)
  private CurrentAirport: any;            // 当前航班
  private CurrentAirTicket: any;          // 当前航班
  private AirTicketReasons: any;          // 选择的原因
  private showDetails: boolean = false;   // 是否打开消费明细弹出层
  private user: any = { UserName: '' };   // 当前选择的用户 || 输入的用户名
  private selectedUserExtraInfo: any;     // 当前选择的用户的其他信息
  private idCard: string = '';            // 身份证号
  private phone: string = '';             // 手机号
  private email: string = '';             // 邮箱
  private isSubmitting: boolean = false;  // 是否正在提交
  private canSubmit: boolean = false;     // 是否可以提交
  private formStatus: any = {             // 表单状态，用于判断是否可以提交
    name: false,      // 姓名是否正确
    idCard: false,    // 身份证号是否正确
    phone: false,     // 手机号是否正确
    email: false,     // 邮箱是否正确
  };
  private formChanged: any = {
    name: false,      // 姓名是否被改动
    idCard: false,    // 身份证号是否被改动
    phone: false,     // 手机号是否被改动
    email: false,     // 邮箱是否被改动
    idCardError: '',  // 身份证错误提示
  };

  @Watch('user.UserName')
  private onNameChange(val: string) {
    this.formStatus.name = Boolean(val);
    this.formChanged.name = true;
    this.checkSubmit();
    this.getUserInfoById();
  }
  @Watch('idCard')
  private onIdCardChange(val: string) {
    this.formStatus.idCard = this.checkIdCard(val);
    this.formChanged.idCardError = this.formStatus.idCard ? '' : this.formChanged.idCardError;
    this.formChanged.idCard = true;
    this.checkSubmit();
  }
  @Watch('phone')
  private onPhoneChange(val: string) {
    const regPhone = /^1[3|4|5|6|7|8|9]\d{9}$/;
    this.formStatus.phone = regPhone.test(val);
    this.formChanged.phone = true;
    this.checkSubmit();
  }
  @Watch('email')
  private onEmailChange(val: string) {
    const regEmail = /^[\w_\.]+@[\w-]+(\.[\w-]+)*\.[0-9a-zA-Z0]{2,6}$/;
    this.formStatus.email = regEmail.test(val);
    this.formChanged.email = true;
    this.checkSubmit();
  }

  // 检查是否可以提交
  private checkSubmit() {
    let canSubmit = true;
    for (const k of Object.keys(this.formStatus)) {
      if (!this.formStatus[k]) {
        canSubmit = false;
      }
    }
    this.canSubmit = canSubmit;
  }

  // 验证身份证是否正确
  private checkIdCard(num: any) {
    let IdCarNote = '身份证格式不正确！';
    let IdCarRight = true;
    // 验证身份证开始
    if (!num) {
      return false;
    }
    num = num.toUpperCase();
    // 身份证号码为15位或者18位，15位时全为数字，18位前17位为数字，最后一位是校验位，可能为数字或字符X。   
    if (!(/(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/.test(num))) {
      IdCarNote = '身份证格式不正确！';
      IdCarRight = false;
    }
    // 校验位按照ISO 7064:1983.MOD 11-2的规定生成，X可以认为是数字10。 
    // 下面分别分析出生日期和校验位 
    let len;
    let re;
    len = num.length;

    if (len === 18) {
      re = new RegExp(/^(\d{6})(\d{4})(\d{2})(\d{2})(\d{3})([0-9]|X)$/);
      let arrSplit = num.match(re);
      if (!arrSplit) {
        return false;
      }
      // 检查生日日期是否正确 
      let dtmBirth = new Date(arrSplit[2] + '/' + arrSplit[3] + '/' + arrSplit[4]);
      let bGoodDay;
      bGoodDay = (dtmBirth.getFullYear() === Number(arrSplit[2])) && ((dtmBirth.getMonth() + 1)
        === Number(arrSplit[3])) && (dtmBirth.getDate() === Number(arrSplit[4]));
      if (!bGoodDay) {
        // checkValidatedShow(obj.id,false,'输入的身份证号里出生日期不对');
        // jAlert('输入的身份证号里出生日期不对', '提示信息')
        IdCarNote = '身份证格式不正确！';
        IdCarRight = false;
      } else {
        // 检验18位身份证的校验码是否正确。 
        // 校验位按照ISO 7064:1983.MOD 11-2的规定生成，X可以认为是数字10。 
        let valnum;
        let arrInt = new Array(7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2);
        let arrCh = new Array('1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2');
        let nTemp = 0;
        for (let i = 0; i < 17; i++) {
          nTemp += num.substr(i, 1) * arrInt[i];
        }
        valnum = arrCh[nTemp % 11];
        if (valnum !== num.substr(17, 1)) {
          IdCarNote = '身份证格式不正确！最后一位应该是：' + valnum;
          IdCarRight = false;
        }
      }
    }
    // 验证身份证结束
    this.formChanged.idCardError = IdCarNote;
    return IdCarRight;
  }

  // 初始化
  private created() {
    this.AirTicketFor = localStorage.getItem('AirTicketFor') || '';
    if (localStorage.getItem('AirTicketTrip')) {
      this.AirTicketTrip = JSON.parse(localStorage.getItem('AirTicketTrip') || '');
    } else {
      this.AirTicketTrip = null;
    }
    console.log(this.AirTicketTrip);
    this.CurrentAirport = JSON.parse(localStorage.getItem('CurrentAirport') || '');
    this.CurrentAirTicket = JSON.parse(localStorage.getItem('CurrentAirTicket') || '');
    this.AirTicketReasons = JSON.parse(localStorage.getItem('AirTicketReason') || '');
    console.log(this.CurrentAirport);
    console.log(this.CurrentAirTicket);
    console.log(this.AirTicketReasons);
    this.getUserIsCommissioner();
    this.getUserInfo();
    if (this.AirTicketFor === 'changeAir') {
      this.getReasonSource();
    }
    // 解决小键盘弹出把footer顶起的问题
    this.windowHeight = document.body.clientHeight;
    window.onresize = () => {
      const height = document.body.clientHeight;
      if (height < this.windowHeight) {
        this.footerPosition = 'static';
      } else {
        this.footerPosition = 'fixed';
      }
    };
  }


  // 获取员工信息
  private async getUserInfo() {
    if (this.AirTicketTrip && this.AirTicketTrip.UserId) {
      this.user.Id = this.AirTicketTrip.UserId;
      this.user.UserName = this.AirTicketTrip.UserName; // 修改姓名会触发监听查询信息
    } else {
      const result = await this.$api.httpGet('basic/Ticket/QueryCurrentUserInfo');
      if (result.Success) {
        // console.log(result.Data);
        this.user = result.Data;
      }
    }
  }

  // 获取用户角色，是否为订票专员
  private async getUserIsCommissioner() {
    const result = await this.$api.httpGet('Membership/TripBookTicket/GetIsBookingTicketRole');
    if (result.Success) {
      // console.log(result.Data);
      this.userRoleType = result.Data ? 2 : 0;
      if (this.AirTicketTrip && result.Data) {
        this.userRoleType = 0;
      }
    }
  }

  // 根据角色ID获取详细信息
  private async getUserInfoById() {
    if (!this.user.Id) {
      return;
    }
    const params: any = {
      id: this.user.Id,
    };
    const result = await this.$api.httpGet('basic/Ticket/QueryUserInfoById', params);
    if (result.Success && result.Data) {
      this.selectedUserExtraInfo = result.Data;
      this.idCard = this.selectedUserExtraInfo.IdentificationCard || '';
      this.phone = this.selectedUserExtraInfo.PhoneNumber || '';
      this.email = this.selectedUserExtraInfo.EnterpriseMail || '';
      this.user.UserCode = this.selectedUserExtraInfo.UserCode;
    } else {
      this.idCard = this.user.IdentificationCard || '';
      this.phone = this.user.PhoneNumber || '';
      this.email = this.user.EnterpriseMail || '';
    }
  }

  // 提交订票
  private async submit() {
    // 如果是重新订票则转到重新订票的方法
    if (this.AirTicketFor === 'rebooking') {
      this.reSubmit();
      return;
    }
    // 如果是改签则转到改签方法
    if (this.AirTicketFor === 'changeAir') {
      this.changeAir();
      return;
    }
    if (this.isSubmitting) {
      return;
    }
    const params: any = {
      AddUserTicketModel: {
        UserId: this.user.Id,
        UserName: this.user.UserName,
        UserCode: this.user.UserCode || this.user.Code,
        TripTrafficId: this.AirTicketTrip ? this.AirTicketTrip.TripTrafficId ? this.AirTicketTrip.TripTrafficId : 'null' : 'null',
        ReasonTypeId: this.AirTicketReasons.id,
        Remark: this.AirTicketReasons ? this.AirTicketReasons.text : '无',
        BusinessTripInfoId: this.AirTicketTrip ? this.AirTicketTrip.BusinessTripInfoId ? this.AirTicketTrip.BusinessTripInfoId : 'null' : 'null', // 出差ID
      },
      Model: {
        name: this.user.UserName,
        email: this.email,
        phone: this.phone,
        cardType: 'NI', // 身份证
        cardNo: this.idCard,
        ageType: 'ADT', // 乘客类型, ADT:成人(默认); CHD:儿 童; INF:婴儿
        departDate: this.CurrentAirport.DepartDate,
        depart: this.CurrentAirport.Depart,
        departTerminal: this.CurrentAirport.DepartTerminal,
        departTime: this.CurrentAirport.DepartTime,
        arrive: this.CurrentAirport.Arrive,
        arriveTerminal: this.CurrentAirport.ArriveTerminal,
        arriveTime: this.CurrentAirport.ArriveTime,
        flightTime: this.CurrentAirport.FlightTime,
        airline: this.CurrentAirport.Airline,
        no: this.CurrentAirport.No,
        operatingNo: this.CurrentAirport.OperatingNo,
        plane: this.CurrentAirport.Plane,
        onTimeRate: this.CurrentAirport.OnTimeRate,
        cabin: this.CurrentAirTicket.Cabin,
        serviceLevel: this.CurrentAirTicket.ServiceLevel,
        meals: this.CurrentAirport.Meals,
        parPrice: this.CurrentAirTicket.ParPrice,
        taxFee: this.CurrentAirport.TaxFee,
        fuelFee: this.CurrentAirport.FuelFee,
        salePrice: this.CurrentAirTicket.SalePrice,
        fdPrice: this.CurrentAirTicket.FdPrice,
        discount: this.CurrentAirTicket.Discount,
        policyId: this.CurrentAirTicket.PolicyId,
        ibeOrHbgj: this.CurrentAirTicket.ibeOrHbgj,
        supplierParam: this.CurrentAirTicket.supplierParam,
      },
    };
    // 检查AddUserTicketModel里的必填参数
    for (const k of Object.keys(params.AddUserTicketModel)) {
      if (!params.AddUserTicketModel[k] && k !== 'Remark') {
        this.$toast('用户或行程信息不完整，请重试');
        return;
      }
    }
    // 检查Model里的必填参数
    const must = ['name', 'email', 'phone', 'cardType', 'cardNo', 'ageType'];
    for (const k of Object.keys(params.Model)) {
      if (!params.Model[k] && must.indexOf(k) !== -1) {
        this.$toast('用户或行程信息不完整，请重试');
        return;
      }
    }
    this.$toast.loading({
      duration: 0,       // 持续展示toast
      forbidClick: true, // 禁用背景点击
      loadingType: 'spinner',
      message: '正在提交...',
    });
    this.isSubmitting = true;
    const result = await this.$api.httpPost('basic/Ticket/PreBookingAirTicket', params);
    if (result.Success && result.Data) {
      const TargetEntityId = result.Data;
      // 提交工作流
      Workflow.Submit('0034', TargetEntityId, (response: any) => {
        if (response.Success && response.Data) {
          this.$toast.clear();
          this.isSubmitting = false;
          // 延时三秒发送企业微信通知
          setTimeout(() => {
            /**
             * 运维需求-去掉前台发消息功能
             */
            // this.SendMessageSubmit(TargetEntityId);
          }, 3000);
          localStorage.setItem('CurrentAirport', JSON.stringify(this.CurrentAirport));
          this.$store.commit('showAirTicketResult');
          if (params.AddUserTicketModel.ReasonTypeId === config.BookingAduitReason_NoNeedAudit) {
            this.$router.push('/airticket-success');
          } else {
            this.$router.push('/airticket-wait');
          }
        } else {
          this.submitError(response.AllMessages);
        }
      }, (error: any) => {
        this.submitError('工作流提交失败');
      });
    } else {
      // 如果返回的信息是重复预定
      if (result.AllMessages === 'repeatbooking') {
        this.$toast.clear();
        this.$dialog.alert({
          message: '您已预订过该航班的机票，请等待预订结果。',
          confirmButtonText: '确定',
        }).then(() => {
          // on close
          this.$router.push('/tripinfo-list');
        });
      } else {
        this.submitError(result.AllMessages);
      }
    }
  }

  // 重新订票
  private async reSubmit() {
    if (this.isSubmitting) {
      return;
    }
    const params: any = {
      LastBookingId: this.AirTicketTrip ? this.AirTicketTrip.Id : '',
      AddUserTicketModel: {
        UserId: this.user.Id,
        UserName: this.user.UserName,
        UserCode: this.user.UserCode || this.user.Code,
        TripTrafficId: this.AirTicketTrip ? this.AirTicketTrip.TripTrafficId ? this.AirTicketTrip.TripTrafficId : 'null' : 'null',
        ReasonTypeId: this.AirTicketReasons.id,
        Remark: this.AirTicketReasons ? this.AirTicketReasons.text : '无',
        BusinessTripInfoId: this.AirTicketTrip ? this.AirTicketTrip.BusinessTripInfoId ? this.AirTicketTrip.BusinessTripInfoId : 'null' : 'null', // 出差ID
      },
      Model: {
        name: this.user.UserName,
        email: this.email,
        phone: this.phone,
        cardType: 'NI', // 身份证
        cardNo: this.idCard,
        ageType: 'ADT', // 乘客类型, ADT:成人(默认); CHD:儿 童; INF:婴儿
        departDate: this.CurrentAirport.DepartDate,
        depart: this.CurrentAirport.Depart,
        departTerminal: this.CurrentAirport.DepartTerminal,
        departTime: this.CurrentAirport.DepartTime,
        arrive: this.CurrentAirport.Arrive,
        arriveTerminal: this.CurrentAirport.ArriveTerminal,
        arriveTime: this.CurrentAirport.ArriveTime,
        flightTime: this.CurrentAirport.FlightTime,
        airline: this.CurrentAirport.Airline,
        no: this.CurrentAirport.No,
        operatingNo: this.CurrentAirport.OperatingNo,
        plane: this.CurrentAirport.Plane,
        onTimeRate: this.CurrentAirport.OnTimeRate,
        cabin: this.CurrentAirTicket.Cabin,
        serviceLevel: this.CurrentAirTicket.ServiceLevel,
        meals: this.CurrentAirport.Meals,
        parPrice: this.CurrentAirTicket.ParPrice,
        taxFee: this.CurrentAirport.TaxFee,
        fuelFee: this.CurrentAirport.FuelFee,
        salePrice: this.CurrentAirTicket.SalePrice,
        fdPrice: this.CurrentAirTicket.FdPrice,
        discount: this.CurrentAirTicket.Discount,
        policyId: this.CurrentAirTicket.PolicyId,
        ibeOrHbgj: this.CurrentAirTicket.ibeOrHbgj,
        supplierParam: this.CurrentAirTicket.supplierParam,
      },
    };
    // 检查AddUserTicketModel里的必填参数
    if (!params.LastBookingId) {
      this.$toast('该行程下没有已预定的机票,无法重新订票');
      return;
    }
    // 检查AddUserTicketModel里的必填参数
    for (const k of Object.keys(params.AddUserTicketModel)) {
      if (!params.AddUserTicketModel[k] && k !== 'Remark') {
        this.$toast('用户或行程信息不完整，请重试');
        return;
      }
    }
    // 检查Model里的必填参数
    const must = ['name', 'email', 'phone', 'cardType', 'cardNo', 'ageType'];
    for (const k of Object.keys(params.Model)) {
      if (!params.Model[k] && must.indexOf(k) !== -1) {
        this.$toast('用户或行程信息不完整，请重试');
        return;
      }
    }
    this.$toast.loading({
      duration: 0,       // 持续展示toast
      forbidClick: true, // 禁用背景点击
      loadingType: 'spinner',
      message: '正在提交...',
    });
    this.isSubmitting = true;
    const result = await this.$api.httpPost('basic/Ticket/RePreBookingAirTicket', params);
    if (result.Success && result.Data) {
      const TargetEntityId = result.Data;
      // 提交工作流
      Workflow.Submit('0034', TargetEntityId, (response: any) => {
        if (response.Success && response.Data) {
          this.$toast.clear();
          this.isSubmitting = false;
          // 延时三秒发送企业微信通知
          setTimeout(() => {
            /**
             * 运维需求-去掉前台发消息功能
             */
            // this.SendMessageSubmit(TargetEntityId);
          }, 3000);
          localStorage.setItem('CurrentAirport', JSON.stringify(this.CurrentAirport));
          this.$store.commit('showAirTicketResult');
          if (params.AddUserTicketModel.ReasonTypeId === config.BookingAduitReason_NoNeedAudit) {
            this.$router.push('/airticket-success');
          } else {
            this.$router.push('/airticket-wait');
          }
        } else {
          this.submitError(response.AllMessages);
        }
      }, (error: any) => {
        this.submitError('工作流提交失败');
      });
    } else {
      this.submitError(result.AllMessages);
    }
  }

  // 改签
  private async changeAir() {
    if (this.isSubmitting) {
      return;
    }
    const params: any = {
      AddUserTicketModel: {
        UserId: this.user.Id,
        UserName: this.user.UserName,
        UserCode: this.user.UserCode || this.user.Code,
        TripTrafficId: this.AirTicketTrip ? this.AirTicketTrip.TripTrafficId ? this.AirTicketTrip.TripTrafficId : 'null' : 'null',
        ReasonTypeId: this.AirTicketReasons.id,
        Remark: this.AirTicketReasons ? this.AirTicketReasons.text : '无',
        BusinessTripInfoId: this.AirTicketTrip ? this.AirTicketTrip.BusinessTripInfoId ? this.AirTicketTrip.BusinessTripInfoId : 'null' : 'null', // 出差ID
      },
      ChangeModel: {
        Id: this.AirTicketTrip ? this.AirTicketTrip.Id : '',
        ReasonTypeId: this.reason.id,
        ReasonTypeValue: this.reason.value,
        Reason: this.Remark,
      },
      Model: {
        name: this.user.UserName,
        email: this.email,
        phone: this.phone,
        cardType: 'NI', // 身份证
        cardNo: this.idCard,
        ageType: 'ADT', // 乘客类型, ADT:成人(默认); CHD:儿 童; INF:婴儿
        departDate: this.CurrentAirport.DepartDate,
        depart: this.CurrentAirport.Depart,
        departTerminal: this.CurrentAirport.DepartTerminal,
        departTime: this.CurrentAirport.DepartTime,
        arrive: this.CurrentAirport.Arrive,
        arriveTerminal: this.CurrentAirport.ArriveTerminal,
        arriveTime: this.CurrentAirport.ArriveTime,
        flightTime: this.CurrentAirport.FlightTime,
        airline: this.CurrentAirport.Airline,
        no: this.CurrentAirport.No,
        operatingNo: this.CurrentAirport.OperatingNo,
        plane: this.CurrentAirport.Plane,
        onTimeRate: this.CurrentAirport.OnTimeRate,
        cabin: this.CurrentAirTicket.Cabin,
        serviceLevel: this.CurrentAirTicket.ServiceLevel,
        meals: this.CurrentAirport.Meals,
        parPrice: this.CurrentAirTicket.ParPrice,
        taxFee: this.CurrentAirport.TaxFee,
        fuelFee: this.CurrentAirport.FuelFee,
        salePrice: this.CurrentAirTicket.SalePrice,
        fdPrice: this.CurrentAirTicket.FdPrice,
        discount: this.CurrentAirTicket.Discount,
        policyId: this.CurrentAirTicket.PolicyId,
        ibeOrHbgj: this.CurrentAirTicket.ibeOrHbgj,
        supplierParam: this.CurrentAirTicket.supplierParam,
      },
    };
    // 检查AddUserTicketModel里的必填参数
    for (const k of Object.keys(params.AddUserTicketModel)) {
      if (!params.AddUserTicketModel[k] && k !== 'Remark') {
        this.$toast('用户或行程信息不完整，请重试');
        return;
      }
    }
    // 检查Model里的必填参数
    const must = ['name', 'email', 'phone', 'cardType', 'cardNo', 'ageType'];
    for (const k of Object.keys(params.Model)) {
      if (!params.Model[k] && must.indexOf(k) !== -1) {
        this.$toast('用户或行程信息不完整，请重试');
        return;
      }
    }
    this.$toast.loading({
      duration: 0,       // 持续展示toast
      forbidClick: true, // 禁用背景点击
      loadingType: 'spinner',
      message: '正在提交...',
    });
    this.isSubmitting = true;
    const result = await this.$api.httpPost('basic/Ticket/ChangeAirTicket', params);
    if (result.Success && result.Data) {
      const TargetEntityId = result.Data;
      // 提交工作流
      Workflow.Submit('0034', TargetEntityId, (response: any) => {
        if (response.Success && response.Data) {
          this.$toast.clear();
          this.isSubmitting = false;
          // 延时三秒发送企业微信通知
          setTimeout(() => {
            /**
             * 运维需求-去掉前台发消息功能
             */
            // this.SendMessageSubmit(TargetEntityId);
          }, 3000);
          localStorage.setItem('CurrentAirport', JSON.stringify(this.CurrentAirport));
          this.$store.commit('showAirTicketResult');
          if (params.AddUserTicketModel.ReasonTypeId === config.BookingAduitReason_NoNeedAudit) {
            this.$router.push('/airticket-success');
          } else {
            this.$router.push('/airticket-wait');
          }
        } else {
          this.submitError(response.AllMessages);
        }
      }, (error: any) => {
        this.submitError('工作流提交失败');
      });
    } else {
      this.submitError(result.AllMessages);
    }
  }

  // 提交失败时的处理
  private submitError(error?: string) {
    this.$toast.clear();
    this.isSubmitting = false;
    this.$store.commit('showAirTicketResult', error);
    this.$router.push('/airticket-error');
  }

  /**
   * 运维需求-去掉前台发消息功能
   */
  // 发送企业微信通知
  // private async SendMessageSubmit(TripTrafficId: string) {
  //   const result = await this.$api.httpGet('Membership/TripBookTicket/SendTicketMessageSubmit', { Id: TripTrafficId });
  //   if (result.Success) {
  //     // this.$toast('微信通知: 已发送通知至企业微信');
  //   }
  // }

  // 获取退改签原因数据源
  private async getReasonSource() {
    this.$toast.loading({
      mask: true,
      message: '加载中...',
      duration: 0,
    });

    const model = {
      UserTicketId: this.AirTicketTrip.Id,
      Type: 0, // 改签
      ChangeDate: this.CurrentAirport.DepartDate,
    };

    const result = await this.$api.httpPost('Membership/TripInfo/GetReturnDataSourceOfReason', model);

    if (result.Success) {
      if (result.Data) {
        this.Reasons = result.Data.map((item: any) => {
          return { id: item.Id, text: item.Value };
        });
      }
      this.$toast.clear();
      this.isLoading = true;
    } else {
      this.$toast.clear();
      this.isLoading = true;
      this.$dialog.alert({
        message: result.AllMessages,
      });
    }
  }

  // 返回
  private back() {
    this.$router.go(-1);
  }

}


